module.exports = __webpack_public_path__ + "media/images/weather/550_night-5d42f5106348b04d7849705d2d83aa33.png";